import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=86c3e200&scoped=true"
import script from "./Patient.vue?vue&type=script&lang=ts"
export * from "./Patient.vue?vue&type=script&lang=ts"
import style0 from "./Patient.vue?vue&type=style&index=0&id=86c3e200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c3e200",
  null
  
)

export default component.exports